<template>
	<v-row class="footer">
		<p>微钢(广州)网络科技有限责任公司</p>
		<p>Copyright © 2020 - {{now}}.</p>
		<div>
			<img src="../views/index/images/mgl-police.png" alt="beian" style="height:14px;width: 14px; margin-right: 5px" />
			<a href="http://www.beian.miit.gov.cn/" class="text-decoration-none">ICP备案：粤ICP备19115765号-1</a>
		</div>
	</v-row>
</template>

<script>
	export default{
		data(){
			return {
				now: ''
			}
		},
		created(){
			let now = new Date();
			let year = now.getFullYear();
			this.now = year;
		}
	}
</script>

<style lang="scss" scoped>
	.footer {
		font-size: 10px;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		margin-bottom: 20px;
		p {
			margin: 0;
		}
	}
</style>
